var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buddha-content"},[_vm._v(" 供佛 供佛 供佛 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }